export const Sales = {
    ClueMarketingLandingPage: '落地页注册',
    NoTimeRangePermissionTip: '该账户暂无可查询时段的数据权限，请联系客户管理团队添加',
    SelectTimeRangeTip: '请选择查询时间范围',
};
